export default __webpack_public_path__ + "11bb6fda9a047469d425a38e414e6af4.png";